import React from 'react';

const StatsCard = ({ icon: Icon, title, value, className }) => {
  return (
    <div className={`stats-card ${className}`}>
      <div className="stats-card-header">
        <Icon size={24} />
        <span className="stats-card-title">{title}</span>
      </div>
      <div className="stats-card-value">{value}</div>
    </div>
  );
};

export default StatsCard;